import { adminHttpClient } from '../../commons/adminHttpClient'

export enum ReportFrequency {
  Monthly,
  Weekly,
}

export type AiAnalyticsReportRequest = {
  startDate: string
  endDate: string
}

const getAiAnalyticsReport = (request: AiAnalyticsReportRequest): Promise<any> => {
  return adminHttpClient.get('Csi/AiAnalyticsReport', request)
}

export default getAiAnalyticsReport
